import common from 'store/modules/common/api'

export const api = {
  ...common.softDeleteApiMethods('Orders'),
  createOrderedBottles: (dto) => common.httpClient.post(`/api/services/app/Orders/CreateOrderedBottles`, dto, common.options(360000)).then(r => common.processResponse(r)), // override PUT
}
